export const destinosDisponibles = [
  { value: "PUJ", label: "Punta Cana" },
  { value: "CUN", label: "Cancún" },
  { value: "GIG", label: "Brasil" },
  { value: "PERU", label: "Perú" },
  { value: "AUA", label: "Aruba" },
  { value: "CUR", label: "Curazao" },
  { value: "MBJ", label: "Jamaica" },
  { value: "PTY", label: "Panamá Playa" },
  { value: "PTYC", label: "Panamá Ciudad" },
  { value: "VRA", label: "Varadero" },
  { value: "HAV", label: "Habana" },
  { value: "PCM", label: "Playa Del Carmen" },
  { value: "MEX", label: "Ciudad de México" },
  { value: "JPN", label: "Japón" },
  { value: "JPN GUIA", label: "Japón Con Guía" },
  { value: "SJD", label: "Los Cabos" },
  { value: "CTG", label: "Cartagena" },
  { value: "SMR", label: "Santa Marta" },
  { value: "ADZ", label: "San Andrés" },
  { value: "BKK", label: "Tailandia" },
  { value: "PTY COMBINADO", label: "Panamá Combinado" },
  { value: "HAV COMBINADO", label: "Habana Combinado" },
  { value: "MEX COMBINADO", label: "México Combinado" },
  { value: "DECAMERON", label: "Decameron" },


]

// Aeropuertos (IATA) a los que realmente se vuela en cada destino. Sirve para
// impedir que el origen sea el mismo lugar del destino aunque el código del
// destino no sea un IATA (PERU, JPN, combinados...) o vuele a otro aeropuerto
// (PCM -> CUN, VRA -> HAV). Ver core/buscarVuelosBaseNormalSerpApi.js del back.
export const aeropuertosDestino = {
  PUJ: ["PUJ"],
  CUN: ["CUN"],
  GIG: ["GIG", "SDU"],
  PERU: ["LIM", "CUZ"],
  AUA: ["AUA"],
  CUR: ["CUR"],
  MBJ: ["MBJ"],
  PTY: ["PTY", "BLB", "RIH"],
  PTYC: ["PTY", "BLB"],
  "PTY COMBINADO": ["PTY", "BLB", "RIH"],
  VRA: ["VRA", "HAV"],
  HAV: ["HAV"],
  "HAV COMBINADO": ["HAV", "VRA"],
  PCM: ["CUN", "TQO"],
  MEX: ["MEX", "NLU"],
  "MEX COMBINADO": ["MEX", "NLU", "CUN"],
  JPN: ["HND", "NRT"],
  "JPN GUIA": ["HND", "NRT"],
  SJD: ["SJD"],
  CTG: ["CTG"],
  SMR: ["SMR"],
  ADZ: ["ADZ"],
  BKK: ["BKK", "DMK", "HKT"],
}

// Código ISO 3166-1 alpha-2 del país de cada destino (para banderas)
export const paisesDestinos = {
  PUJ: "do",
  CUN: "mx",
  GIG: "br",
  PERU: "pe",
  AUA: "aw",
  CUR: "cw",
  MBJ: "jm",
  PTY: "pa",
  PTYC: "pa",
  "PTY COMBINADO": "pa",
  VRA: "cu",
  HAV: "cu",
  "HAV COMBINADO": "cu",
  PCM: "mx",
  MEX: "mx",
  "MEX COMBINADO": "mx",
  SJD: "mx",
  JPN: "jp",
  "JPN GUIA": "jp",
  CTG: "co",
  SMR: "co",
  ADZ: "co",
  BKK: "th",
}